import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "./Preview_Modal.css"; // We'll style it similarly to your screenshot
import Common_Btn from "../../common-btn/Common_Btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

const Preview_Modal = ({ show, onHide, file, onUploadNew, onDelete }) => {
  if (!file) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      centered
      dialogClassName="document-modal"
      backdropClassName="document-backdrop"
    >
      <Modal.Body className="document-modal-body text-center">
        <div className="document-modal-header">
          <span className="back-btn" onClick={onHide}>
            Back
          </span>
          <span className="file-name">{file.name}</span>
          <span className="close-btn" onClick={onHide}>
            ✕
          </span>
        </div>
        <img src={file.preview} alt={file.name} className="document-image" />

        <Modal.Footer className="justify-content-end g-2 modal_footer">
          {/* <Common_Btn btnText="Upload New" onClick={onUploadNew} /> */}
          <div className="delete_icon_holder" onClick={onDelete}>
            <FontAwesomeIcon icon={faTrash} style={{ color: "#ffffff" }} />
          </div>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default Preview_Modal;
